import React, { useEffect } from 'react';
import BasePage from '../../../components/BasePage'
import { connect } from 'react-redux'
import queryString from 'query-string';
import { memberActions } from "../../../state/ducks/member";
import { ResetPasswordForm } from './ResetPasswordForm';
import { jumpTo } from '../../../helpers';


type ValidateResetTokenRequest = {
  token: string,
  signature: string,
}

type ValidateResetTokenSuccess = {
  success: true,
  email: string,
  expiredAt: string
}

type ApiRequestFailure = {
  success: false,
  errors: string[]
}

type ValidateResetTokenResponse  = ValidateResetTokenSuccess | ApiRequestFailure

type ResetPasswordRequest = {
  token: string,
  signature: string,
  password: string,
}

type ResetPasswordSuccess = {
  success: true,
  message: string,
}

type ResetPasswordResponse = ResetPasswordSuccess | ApiRequestFailure

type ResetPasswordProps = {
  location: {
    search: string
  },
  validateResetToken: (data: ValidateResetTokenRequest, errorHandler: (response: ValidateResetTokenResponse) => void) => Promise<ValidateResetTokenResponse>,
  resetPassword: (data: ResetPasswordRequest, errorHandler?: (response: ResetPasswordResponse) => void) => Promise<ResetPasswordResponse>,
}

function ResetPassword({location, validateResetToken, resetPassword}: ResetPasswordProps) {

  const [message, setMessage] = React.useState('');
  const [values, setValues] = React.useState({
    token: '',
    signature: '',
    email: '',
  })

  // read token and sig from query params to verify the request

  useEffect(() => {
    const params = queryString.parse(location.search);

    if (!params.token || !params.sig) {
      setMessage('Invalid reset password link. Please check your email and try again.');
      return;
    }

    // validate the token and sig with the backend API
    const request = {token: params.token as string, signature: params.sig as string};
    // omit any error thrown by the api call here since we don't want to show details of the failure to users

    const requestNewMessage = 'The reset password link is invalid or has expired. Please request a new one from the login page.'
    validateResetToken(request, () => {})
      .then(response => {
        if(!response) {
          setMessage(requestNewMessage);
          return;
        }

        if (response.success) {
          setValues({
            token: params.token as string,
            signature: params.sig as string,
            email: response.email,
          })
        } 
        else {
          const errors = response.errors.join(' ');
          setMessage(errors || requestNewMessage);
        }
      })
      .catch(() => {
        setMessage(requestNewMessage);
      })
  }, [])

  const handleSubmit = async (data: { password: string }) => {
   
    console.log('submit new password', data)
    const requestData = {
      token: values.token,
      signature: values.signature,
      password: data.password,
    }

    const result = await resetPassword(requestData)
    if(!result) {
      setMessage('Failed to reset password. Please try again later.');
      return;
    }

    if(result.success) {
      setMessage('Your password has been reset successfully. Please go to the login page to sign in with your new password.');
    }
    else {
      const errors = result.errors.join(' ');
      setMessage(errors || 'Failed to reset password. Please try again later.');
    }
    
  }


  return (
    <BasePage containerClass="mobile-view">
      <div className="page-container">
        <div className="card-container">
          <div className="card-content">
            <div className="heading">Reset Password</div>
            {message 
              ? <div className="form-content tw-flex tw-flex-col tw-gap-4">
                  <div>{message}</div>
                  <div className="actions">
                    <button type="submit" onClick={() => jumpTo('/member')}>Go to Login Page</button>
                  </div>
                </div> 
              : <ResetPasswordForm email={values.email} onSubmit={handleSubmit} />
            }
          </div>
        </div>
      </div>
    </BasePage>
  )
}


function mapStateToProps() {
  return {
  }
}

const mapDispatchToProps = {
  ...memberActions,
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);